export const PRIMARY_VIDEO_MIME = 'video/mp4; codecs=hvc1.1.6.L63.00';
export const SECONDARY_VIDEO_MIME = 'video/mp4; codecs=avc1.64001E';
